import FieldFileInput from './FieldFileInput';

export default FieldFileInput;
